import { render, staticRenderFns } from "./DashboardSelect.vue?vue&type=template&id=90e9706e&scoped=true"
import script from "./DashboardSelect.vue?vue&type=script&lang=js"
export * from "./DashboardSelect.vue?vue&type=script&lang=js"
import style0 from "./DashboardSelect.vue?vue&type=style&index=0&id=90e9706e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90e9706e",
  null
  
)

export default component.exports